import { InputNumber } from "antd";
import React, { useCallback } from "react";
import { GlobalManualAdjustmentItem } from "src/modules/GlobalManualAdjustmentsManager/types/types";

type ISimpleNumberInputCell = {
  item: GlobalManualAdjustmentItem;
  disabled?: boolean;
  defaultValue: number | undefined;
  onSave: (value: number, item: GlobalManualAdjustmentItem) => Promise<void>;
};

export const SimpleNumberInputCell = React.memo(
  ({ item, disabled, defaultValue, onSave }: ISimpleNumberInputCell) => {
    const handleSave = useCallback(
      async (
        e:
          | React.FocusEvent<HTMLInputElement>
          | React.KeyboardEvent<HTMLInputElement>,
      ) => {
        const value = (e.target as HTMLInputElement)?.value;

        await onSave(Number(value) ?? 0, item);
      },
      [onSave, item],
    );

    return (
      <InputNumber
        disabled={disabled}
        controls={false}
        defaultValue={defaultValue}
        precision={2}
        suffix={item.currencyCode}
        onChange={async (_value: number | null) => {}}
        style={{ width: "100%" }}
        onBlur={handleSave}
        onPressEnter={handleSave}
      />
    );
  },
);
